import { HeroSecondary } from "../headers/HeroSecondary";
import { SectionGridTwoColumns } from "../sections/grids/SectionGridTwoColumns";
import { WrapperComponents } from "../wrappers/WrapperComponents";
import { SectionBlockTextColumns } from "../sections/blocks/SectionBlockTextColumns";
import { SectionBlockVideo } from "../sections/blocks/SectionBlockVideo";
import { SectionBlockMediaFeatured } from "../sections/blocks/SectionBlockMediaFeatured";
import { SectionBlockQuote } from "../sections/blocks/SectionBlockQuote";
import { SectionBlockTextMedia } from "../sections/blocks/SectionBlockTextMedia";
import { SectionBlockText } from "../sections/blocks/SectionBlockText";

export interface ITemplateFlexible {
  data: any;
}

export default function TemplateFlexible({ data }: ITemplateFlexible) {
  const { heroSecondary, flexibleComponents, breadcrumbs } = data;

  // console.log("templateFlexible", data);
  return (
    <>
      {heroSecondary && (
        <HeroSecondary data={heroSecondary} breadcrumbs={breadcrumbs} />
      )}

      <WrapperComponents>
        {flexibleComponents &&
          flexibleComponents.map((component: any, index: number) => {
            switch (component._type) {
              case "sectionBlockTextColumns":
                return <SectionBlockTextColumns key={index} data={component} />;
              case "sectionBlockVideo":
                return <SectionBlockVideo key={index} data={component} />;
              case "testimonial":
                return (
                  <SectionBlockMediaFeatured key={index} data={component} />
                );
              case "sectionGridTwoColumns":
                return <SectionGridTwoColumns key={index} data={component} />;
              case "blockQuote":
                return <SectionBlockQuote key={index} data={component} />;
              case "sectionBlockTextMedia":
                return <SectionBlockTextMedia key={index} data={component} />;
              case "blockText":
                return <SectionBlockText key={index} data={component} />;
              default:
                return null;
            }
          })}
      </WrapperComponents>
    </>
  );
}
